import { useEffect } from "react";
import { Form, Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { CheckCircleOutlined, CloseOutlined } from "@ant-design/icons";
import usePost from "../../../global/hooks/usePost";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import { SipIcon } from "./../../../assets/images/vectors/SideBarIcons/SipIcon";
import CustomTextArea from "./../../../global/components/inputWidgets/CustomTextArea";

export const AddSipByListForm = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const postUrl = `${process.env.REACT_APP_API_URL}/api/sips/bulk-create/`;
  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(postUrl);

  const onFinish = async (values) => {
    try {
      const text = values.sip?.trim();
      if (!text) {
        openErrorNotification("SIP List cannot be empty.");
        return;
      }
      const words = text
        .split(/\s+/) // split by any space or newline
        .filter(Boolean);

      if (words.length % 2 !== 0) {
        openErrorNotification(
          "Invalid input. Each SIP ID must have a matching password."
        );
        return;
      }

      const sipIds = [];
      const passwords = [];

      for (let i = 0; i < words.length; i += 2) {
        sipIds.push(words[i]);
        passwords.push(words[i + 1]);
      }

      await postAction({
        SipId: sipIds.join(", "),
        Password: passwords.join(", "),
      });
    } catch (error) {
      openErrorNotification("Something went wrong.");
      console.error(error);
    }
  };

  const onReset = () => {
    // form.resetFields();
    navigate(-1);
  };

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong"
      );
    } else if (!postLoading && !postError && postData) {
      openConfirmNotification("Success");

      setTimeout(() => {
        navigate(-1);
      }, 200);
    }
  }, [postError, postData, postLoading]);

  // Set default field value

  const breadcrumbItems = [
    {
      label: "SIP",
      href: "/sip",
    },
    {
      label: "Add By List",
      href: "/sip/addSipByList",
    },
  ];

  const buttonsData = [
    // {
    //   label: "List",
    //   icon: <UnorderedListOutlined />,
    //   onClick: () => {
    //     navigate("/devicelist");
    //   },
    // },
    {
      label: "Apply",
      icon: <CheckCircleOutlined />,
      onClick: () => form.submit(),
    },
    {
      label: "Cancel",
      icon: <CloseOutlined />,
      onClick: onReset,
    },
  ];

  return (
    <div>
      <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
        <CommonButton buttonsData={buttonsData} />
      </CommonBreadcrumb>
      <>
        <Form
          validateTrigger={"onChange"}
          form={form}
          onFinish={onFinish}
          scrollToFirstError
          layout={"vertical"}
          autoComplete={"off"}
        >
          <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
            <div className="flex items-center bg-gray-200 p-2.5">
              <SipIcon className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                SIP
              </span>
            </div>
            <div className="px-2 pt-1 pb-3">
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomTextArea
                    label="SIP ID & Password List "
                    name="sip"
                    // placeholder="SIP List"
                    rows={4}
                    // maxLength={200}
                    required
                  />
                </Col>
              </Row>
            </div>
          </div>
        </Form>
      </>
    </div>
  );
};
